<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "PJProposalOtherInformation",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label:
						"1. Have you or any person residing with you, ever been convicted of any offence involving dishonesty?",
					component: "select",
					bindTo: "case.facts.isOffenceConvicted",
					props: {
						options: [
							{
								name: "No",
								value: "No"
							},
							{
								name: "Yes",
								value: "Yes"
							}
						]
					}
				},
				{
					label: '1. If chose "Yes", please give details',
					component: "text",
					bindTo: "case.facts.offenceConvictedDetails"
				},
				{
					label:
						"2. Are there any other factors affecting or likely to affect this insurance of which you are aware?",
					component: "select",
					bindTo: "case.facts.isOtherFactorsAffecting",
					props: {
						options: [
							{
								name: "No",
								value: "No"
							},
							{
								name: "Yes",
								value: "Yes"
							}
						]
					}
				},
				{
					label: '2. If chose "Yes", please give details',
					component: "text",
					bindTo: "case.facts.otherFactorsAffectingDetails"
				}
			]
		}
	}
}
</script>
